// removed by extract-text-webpack-plugin
module.exports = {"footer":"VUGIPjGgHtzvbHiU19iTQ","container":"_39nRGroSVk5gNNY78cAja3","slink-group":"_2mXybDL-uYMuCkzxlRvsEf","links":"_3GWS2QhxFzS89zdr488SZl","social":"_3VAjbySL-V-og-nihq3rCY","logo-link":"VWpMkLHnaFRwA_YOJVKEr","followUsLabel":"_9UP2kGkL1LAH7icrUNmM0","stock":"_319JpkbeXaJiCm_cfathdM","stock-value":"_2eGqySYB34u8kaxhSGfj72","stock-difference":"_1yn758a_h2DxbMNknfMU6u","is-visible":"_2BjQwohHus5dSh4Z856X8v","stock-difference-positive":"_2g11OX24gkv2NSLz4-j2UC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/Footer.module.scss
// module id = 766
// module chunks = 0